import { render, staticRenderFns } from "./FreedomCompete2.vue?vue&type=template&id=3ee77503&scoped=true&"
import script from "./FreedomCompete2.vue?vue&type=script&lang=js&"
export * from "./FreedomCompete2.vue?vue&type=script&lang=js&"
import style0 from "./FreedomCompete2.vue?vue&type=style&index=0&id=3ee77503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee77503",
  null
  
)

export default component.exports